import PropTypes from "prop-types";
import * as React from "react";
import { Select, Typography } from "../../themeV2";
import { getSubverticalList, useVerticals } from "../../hooks/useVerticals";
import styles from "./AddShopDialog.module.css";
import { ACTION } from "./addShopReducer";

function VerticalSection({ vertical, subvertical, dispatch }) {
  const { verticalList } = useVerticals();

  const subverticalList = React.useMemo(
    () => getSubverticalList(vertical),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [vertical, verticalList],
  );

  const handleVerticalChange = (e) => {
    const raw = e.target.value;
    const selected =
      raw === "" ? null : verticalList.find((v) => v.id === Number(raw));
    dispatch({
      type: ACTION.SET_FIELD,
      field: "vertical",
      value: selected ?? null,
    });
    dispatch({
      type: ACTION.SET_FIELD,
      field: "subvertical",
      value: null,
    });
  };

  const handleSubverticalChange = (e) => {
    const raw = e.target.value;
    const selected =
      raw === "" ? null : subverticalList.find((s) => s.id === Number(raw));
    dispatch({
      type: ACTION.SET_FIELD,
      field: "subvertical",
      value: selected ?? null,
    });
  };

  return (
    <section className={styles.section}>
      <Typography variant="title-md" as="h3">
        Vertical / category
      </Typography>

      <div className={styles.verticalRow}>
        <Select.Root
          label="Vertical"
          placeholder="None"
          value={vertical?.id ? String(vertical.id) : ""}
          onValueChange={handleVerticalChange}
        >
          <Select.Item value="">None</Select.Item>
          {verticalList
            .filter((v) => v.id !== 0)
            .map((v) => (
              <Select.Item key={v.id} value={String(v.id)}>
                {v.name}
              </Select.Item>
            ))}
        </Select.Root>

        <Select.Root
          label="Subvertical"
          placeholder="None"
          disabled={!vertical || vertical.id === 0}
          value={subvertical ? String(subvertical.id) : ""}
          onValueChange={handleSubverticalChange}
        >
          <Select.Item value="">None</Select.Item>
          {subverticalList
            .filter((s) => s.id !== 0)
            .map((s) => (
              <Select.Item key={s.id} value={String(s.id)}>
                {s.name}
              </Select.Item>
            ))}
        </Select.Root>
      </div>
    </section>
  );
}

VerticalSection.propTypes = {
  vertical: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
  }),
  subvertical: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
  }),
  dispatch: PropTypes.func.isRequired,
};

export default React.memo(VerticalSection);
